import { hasActiveConsumerSubscription } from "./consumerSubscription";

type CheckoutProfile = { id: string; plan?: string | null; subscriptionStatus?: string | null };

/** Keep the original scheduling page alive while its checkout runs elsewhere. */
export function watchScheduleCheckout({
  checkoutWindow, ownerId, isCurrent, refetchProfile, onPaid,
  intervalMs = 5_000, timeoutMs = 30 * 60_000,
  ignoreWindowClosed = false,
}: {
  checkoutWindow: Pick<Window, "closed">;
  ownerId: string;
  isCurrent: () => boolean;
  refetchProfile: () => Promise<{ data?: CheckoutProfile }>;
  onPaid: () => void;
  intervalMs?: number;
  timeoutMs?: number;
  ignoreWindowClosed?: boolean;
}): () => void {
  let stopped = false;
  let reading = false;
  const stop = () => {
    stopped = true;
    clearInterval(interval);
    clearTimeout(timeout);
  };
  const check = async () => {
    if (stopped) return;
    if (!isCurrent() || (!ignoreWindowClosed && checkoutWindow.closed)) { stop(); return; }
    if (reading) return;
    reading = true;
    try {
      const { data } = await refetchProfile();
      if (!stopped && isCurrent() && data?.id === ownerId && hasActiveConsumerSubscription(data)) {
        stop();
        onPaid();
      }
    } catch {
      // A transient read failure leaves the same checkout and draft in place.
    } finally { reading = false; }
  };
  const interval = setInterval(() => { void check(); }, intervalMs);
  const timeout = setTimeout(stop, timeoutMs);
  void check();
  return stop;
}
